import React from "react";
import ExcelJS from "exceljs";

const ExcelBankPolicyReport = ({ data }) => {
    const exportExcelFile = async () => {
        if (!Array.isArray(data) || data.length === 0) {
            console.error("Data is not an array or empty:", data);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Bank Policies');

        // Define columns with headers based on your data structure
        worksheet.columns = [
            { header: 'S.No', key: 'serial', width: 8 },
            { header: 'Bank Name', key: 'bank_name', width: 25 },
            { header: 'Product Name', key: 'product_name', width: 15 },
            { header: 'Policies', key: 'policies', width: 50 },
            { header: 'Don\'t Policies', key: 'dont_policies', width: 50 },
        ];

        // Apply alignment and color to header cells
        worksheet.getRow(1).eachCell((cell) => {
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFF00' }, // Yellow color
            };
            cell.font = { bold: true, size: 12 };
        });

        // Flatten the data for export
        const flattenedData = data.map((item, index) => {
            // Format policies as bullet points or comma-separated list
            const policies = Array.isArray(item.policy_names)
                ? item.policy_names.map(p => `• ${p}`).join('\n')
                : '-';

            const dontPolicies = Array.isArray(item.dont_policy_names)
                ? item.dont_policy_names.map(p => `• ${p}`).join('\n')
                : '-';

            return {
                serial: index + 1,
                bank_name: item.bank_name || '-',
                product_name: item.product_name || '-',
                policies: policies,
                dont_policies: dontPolicies,
            };
        });

        // Add data rows with custom cell alignment
        flattenedData.forEach((item) => {
            const row = worksheet.addRow(item);

            // Apply formatting to each cell
            row.eachCell((cell, colNumber) => {
                // Default alignment for all cells
                cell.alignment = {
                    vertical: 'top',
                    horizontal: 'left',
                    wrapText: true
                };

                // Special formatting for specific columns
                if (colNumber === 1) { // S.No column
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                    cell.font = { bold: true };
                } else if (colNumber === 4 || colNumber === 5) { // Policies and Don't Policies columns
                    // Keep the bullet points formatting
                    cell.alignment = {
                        vertical: 'top',
                        horizontal: 'left',
                        wrapText: true
                    };
                }
            });
        });

        // Auto-filter for better data management
        worksheet.autoFilter = {
            from: 'A1',
            to: 'E1'
        };

        // Add borders to all cells
        worksheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
        });

        // Set row heights for better visibility of multi-line content
        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber > 1) { // Skip header row
                row.height = 100; // Increased height for policy content
            } else {
                row.height = 30; // Header row height
            }
        });

        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Generate Excel file buffer
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `Bank_Policy_Report_${formattedDate}.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <button
            className="btn btn-success mt-1"
            onClick={exportExcelFile}
            style={{ marginLeft: '10px' }}
        >
            <i className="feather icon-download"></i> Download as Excel
        </button>
    );
};

export default ExcelBankPolicyReport;